<template>
  <v-container fluid>
    <v-file-input 
      v-if="addEnable==0"      
      v-model="file"
      label="Upload File"
      @change="uploadFile"     
      prepend-icon="none"
      append-icon="mdi-upload"
      class="mb-4 vfile"      
    ></v-file-input>
    <v-list class="vlist">
      <v-list-item v-for="file in files" :key="file.id"  >        
        <div class="file-details">
          <v-avatar class="color-dot" :style="{ backgroundColor: 'black' }"></v-avatar>
          <div>
            <v-list-item-title>
              <a :href="server + `/uploads/${file.filename}`" target="_blank" :title="file.username + ': ' + file.originalname" style="color:black">{{ truncateFilename(file.originalname) }}</a>
            </v-list-item-title>
            <v-list-item-subtitle>{{ new Date(file.timestamp).toLocaleString() }}</v-list-item-subtitle>
          </div>
          <v-btn v-if="file.username === currentUsername || isadmin==1" @click="removeFile(file.id)" class="delete-button">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FileUploader',
  props: {
    section: Number, // Aggiungi la prop section
    currentUsername: String, // Aggiungi la prop currentUsername
    color: String,   
    isadmin: [String, Number], // Accetta sia stringhe che numeri
    addEnable: {
      type: [String, Number],
      default: 0
    },
  },
  data() {
    return {
      file: null,
      files: [],
      username: localStorage.getItem('user'), // Ottieni il nome utente dal localStorage
    };
  },
  computed: {   
    colorClass() {
      console.log(this.color)
      
      if(this.files.length > 0)
      {
        if(this.color === "teal")      
          return `border-blue`;
        else      
          return `border-${this.color}`;
      }
      else
        return '';
    }
  },
  methods: {
    truncateFilename(filename) {
      return filename.length > 10 ? filename.substring(0, 10) + '...' : filename;
    },
    async uploadFile() {
      const token = localStorage.getItem('token');

      const formData = new FormData();
      formData.append('file', this.file);
      const response = await axios.post(process.env.VUE_APP_SERVER3 + '/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `${token}`
        },
      });
      // Invia i dettagli del file al server
      await axios.post(process.env.VUE_APP_SERVER3 + '/files', {
        filename: response.data.filename,
        originalname: response.data.originalname,
        timestamp: Date.now(),
        section: this.section, // Aggiungi la sezione al file
        username: this.username, // Aggiungi il nome utente al file
      }, {
        headers: {
          'Authorization': `${token}`
        }
      });

      this.loadFiles();
    },
    async loadFiles() {
      const response = await axios.get(process.env.VUE_APP_SERVER3 + '/files', {
        params: { section: this.section },
      });
      console.log('files:' ,response.data)
      this.files = response.data;
      this.file = null;
    },
    async removeFile(id) {
      if (confirm('Are you sure you want to delete this file?')) {
        const token = localStorage.getItem('token');
        await axios.delete(process.env.VUE_APP_SERVER3 + `/files/${id}`,{
            headers: { Authorization: token },
        });
        this.loadFiles();
      }
    },
  },
  watch: {
    section() {
      this.loadFiles(); // Ricarica i file quando cambia la sezione
    }
  },
  mounted() {
    this.server = process.env.VUE_APP_SERVER3;
    console.log('addEnable: ',this.addEnable)
    this.loadFiles();
  },
};
</script>

<style scoped>
.vfile {
  height: 70px;
  padding: 6px;
  background-image: url('@/assets/Iridescent_Light_Spectrum.jpg');
  border-radius: 20px;
  background-size: cover; /* Adatta l'immagine alla dimensione del bottone */
  background-position: center; /* Centra l'immagine nel bottone */
  color: white !important; /* Colore del testo per contrastare con l'immagine di sfondo */
  animation: bounce 1s infinite;
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
.vlist{
  background-color: white;
  border-radius: 5px;  
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.color-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
  background-color: currentColor;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 5px; /* Aggiunge un po' di padding per migliorare la visualizzazione */
  margin-bottom: 5px; /* Aggiunge uno spazio tra gli elementi della lista */  
}
.list-item {    
  padding: 5px; /* Aggiunge un po' di padding per migliorare la visualizzazione */  
}

.border-green {
  border: 1px solid green;
}

.border-blue {
  border: 1px solid blue;
}

.border-orange {
  border: 1px solid orange;
}

.border-purple {
  border: 1px solid purple;
}

.border-black {
  border: 1px solid black;  
}

.file-details {
  display: flex;
  align-items: center;
  width: 100%;  
}

.delete-button {
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 0 !important;
  padding: 10px !important;
  font-size: 10px !important; /* Adjust the size as needed */
  color: red; /* Optional: Adjust the color if needed */  
  margin-left: 5px;
}

.delete-button:hover {
  background-color: white !important;
  box-shadow: none !important;
}
</style>
